import { z } from 'zod'

export enum ALERTS_CONTROL {
  ACTIVE = 'Active',
  TRIGGERED = 'Triggered',
}

export type FormData = z.infer<typeof formSchema>

export const formSchema = z.object({
  execution_price: z.string().min(1, 'Required'),
  note: z.string(),
  side: z.string(),
  market_id: z.string().min(1, 'Required'),
})

export type AlertType = FormData &
  {
    uuid: string;
    completed_at: number | null,
  }
